// Auto-extracted schema
export const WISC5_SUBTESTS = [
  { var: "cubos", label: "Construcción con cubos (Diseño con cubos):" },
  { var: "analogias", label: "Analogías (Semejanzas):" },
  { var: "retencion_de_digitos", label: "Retención de dígitos:" },
  { var: "matrices_de_razonamiento", label: "Matrices de razonamiento:" },
  { var: "vocabulario", label: "Vocabulario:" },
  { var: "aritmetica", label: "Arimética:" },
  { var: "busqueda_de_simbolos", label: "Búsqueda de símbolos:" },
  { var: "rompecabezas_visuales", label: "Rompecabezas visuales:" },
  { var: "informacion", label: "Información:" },
  { var: "claves", label: "Claves:" },
  { var: "secuenciacion_letras_numeros", label: "Secuenciación Letras-Números:" },
  { var: "balanzas", label: "Balanzas (Peso figurado):" },
  { var: "comprension", label: "Comprensión:" },
  { var: "cancelacion", label: "Cancelación:" },
  { var: "retencion_imagenes", label: "Retención de Imágenes:" },
];

export const WISC5_CONFIG = [
  { var: "metodo_discrepancia", label: "Método para calcular la discrepancia:", options: [
    { value: "critico_0.01", text: "Valor crítico (0.01)" },
    { value: "critico_0.05", text: "Valor crítico (0.05)" },
    { value: "critico_0.1", text: "Valor crítico (0.1)" },
    { value: "critico_0.15", text: "Valor crítico (0.15)" },
    { value: "base_<=25", text: "Tasa base <=25" },
    { value: "base_<=15", text: "Tasa base <=15" },
    { value: "base_<=10", text: "Tasa base <=10" },
    { value: "base_<=5", text: "Tasa base <=5" },
    { value: "base_<=2", text: "Tasa base <=2" },
  ]},
  { var: "comparaciones", label: "comparaciones:", options: [
    { value: "cit", text: "comparar con CI total" },
    { value: "pip", text: "comparar promedio de índices principales (PIP)" },
  ]},
  { var: "tipo", label: "Tipo de puntaje:", options: [
    { value: "Bruto", text: "Bruto" },
    { value: "Equivalente", text: "Equivalente" },
  ]},
  { var: "confianza", label: "Nivel de confianza:", options: [
    { value: "conf95", text: "95%" },
    { value: "conf90", text: "90%" },
  ]},
  { var: "grup_refer", label: "Grupo de referencia Tasa base:", options: [
    { value: "total", text: "Muestra Total" },
    { value: "nivel", text: "Nivel de Habilidad" },
  ]},
  { var: "compara_subp", label: "Base de comparación subpruebas ", options: [
    { value: "PPE-P", text: "PPE-P" },
    { value: "PPE-C", text: "PPE-C" },
  ]},
  { var: "signif_pares", label: "Valor crítico de diferencias entre pares de índices ", options: [
    { value: "0.01", text: "0.01" },
    { value: "0.05", text: "0.05" },
    { value: "0.1", text: "0.1" },
    { value: "0.15", text: "0.15" },
  ]},
];

export const WISC5_DEFAULTS = {"metodo_discrepancia": "critico_0.01", "comparaciones": "pip", "tipo": "Bruto", "confianza": "conf95", "grup_refer": "total", "compara_subp": "PPE-P", "signif_pares": "0.01"};
